import { CLICK_TYPE, NOTIFICATION_TYPE } from '../NotificationComponent/notification-component';
import { NOTIFICATION_ACTION, NOTIFICATION_MESSAGE } from 'home/view/upgrade-order/constants';
import React, { useState, useEffect, Fragment } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Notification } from '../NotificationComponent/notification-component';
import './OvRejection.scss';
import { ORDER_STATUS, ORDER_REMARK } from 'home/view/upgrade-order/constants';
export const OvRejection = ({ orderDetail }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [notificationContent, setNotificationContent] = useState();

  const handleNotficationEvent = ({ nodeInfo, event, innerText }) => {
    const { action } = nodeInfo;
    switch (action) {
      case NOTIFICATION_ACTION.VIEW_MORE:
        setIsExpanded(!isExpanded);
        break;
      default:
        break;
    }
  };

  const renderViewMoreReason = (remarks) => {
    const reasons = isExpanded ? remarks.slice(0, remarks.length) : remarks.slice(0, 1);
    return (
      <Fragment>
        <ul className="view-more">
          {reasons.map((reason, index) => {
            return (
              <li className="view-more-list" key={uuidv4()}>
                {' '}
                {reason}
              </li>
            );
          })}
        </ul>
      </Fragment>
    );
  };

  useEffect(() => {
    if (orderDetail.orderStatus === ORDER_STATUS.OV_REJECTED) {
      const remarks = orderDetail ? orderDetail.remarks.split(',') : '';
      const reasons = isExpanded ? remarks.slice(0, remarks.length) : remarks.slice(0, 1);
      const viewMore = (
        <a className="view-more-button" type="link" href="javascript:void(0);" role="button" tabindex="0">
          <strong id="link" data-type={CLICK_TYPE.LINK} data-name={NOTIFICATION_ACTION.VIEW_MORE} data-action={NOTIFICATION_ACTION.VIEW_MORE}>
            {' '}
            {reasons.length > 1 && isExpanded ? 'View less ' : 'View more'}
          </strong>
        </a>
      );
      const notificationContent = (
        <React.Fragment>
          <span className="notification-text-ov">
            <span className="notification-text-list">
              {' '}
              <strong className="bold-text">{NOTIFICATION_MESSAGE.ORDER_REJECTED}</strong> {NOTIFICATION_MESSAGE.ORDER_REJECTED_BEACUSE} {renderViewMoreReason(remarks)}
            </span>
            {remarks.length > 1 ? <span className="view-more-text">{viewMore}</span> : null}
          </span>
        </React.Fragment>
      );
      setNotificationContent(notificationContent);
    }
    return () => {
      setNotificationContent('');
    };
  }, [orderDetail, isExpanded]);

  return (
    <Fragment>
      <section id="notification" className="ov_reject_single_upgrade">
        <Notification show={true} type={NOTIFICATION_TYPE.ERROR} message={notificationContent} eventHandler={handleNotficationEvent}></Notification>
      </section>
    </Fragment>
  );
};
